import { render, staticRenderFns } from "./marginAudit.vue?vue&type=template&id=d6f66974&scoped=true&"
import script from "./marginAudit.vue?vue&type=script&lang=js&"
export * from "./marginAudit.vue?vue&type=script&lang=js&"
import style0 from "./marginAudit.vue?vue&type=style&index=0&id=d6f66974&prod&lang=less&scoped=true&"
import style1 from "./marginAudit.vue?vue&type=style&index=1&id=d6f66974&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f66974",
  null
  
)

export default component.exports